// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowDownRightAndArrowUpLeft16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-down-right-and-arrow-up-left': IconArrowDownRightAndArrowUpLeft;
    }
}

/**
 * The icon component for the 'arrowDownRightAndArrowUpLeft' icon
 */
export class IconArrowDownRightAndArrowUpLeft extends IconSvg {
    public constructor() {
        super(arrowDownRightAndArrowUpLeft16X16);
    }
}

registerIconSvg('icon-arrow-down-right-and-arrow-up-left', IconArrowDownRightAndArrowUpLeft);
export const iconArrowDownRightAndArrowUpLeftTag = 'nimble-icon-arrow-down-right-and-arrow-up-left';
